function cov_2da4l8odm5() {
  var path = "/app/src/utils/create-normalize-checking.tsx";
  var hash = "2a9b4835d8ff0aca79aa0ba3c58ba81f0c64917e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/create-normalize-checking.tsx",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 2
        },
        end: {
          line: 22,
          column: 3
        }
      },
      "1": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 22,
          column: 3
        }
      },
      "2": {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 21,
          column: 5
        }
      },
      "3": {
        start: {
          line: 10,
          column: 6
        },
        end: {
          line: 10,
          column: 38
        }
      },
      "4": {
        start: {
          line: 10,
          column: 18
        },
        end: {
          line: 10,
          column: 38
        }
      },
      "5": {
        start: {
          line: 12,
          column: 21
        },
        end: {
          line: 12,
          column: 37
        }
      },
      "6": {
        start: {
          line: 14,
          column: 6
        },
        end: {
          line: 14,
          column: 42
        }
      },
      "7": {
        start: {
          line: 14,
          column: 28
        },
        end: {
          line: 14,
          column: 42
        }
      },
      "8": {
        start: {
          line: 16,
          column: 6
        },
        end: {
          line: 16,
          column: 41
        }
      },
      "9": {
        start: {
          line: 19,
          column: 6
        },
        end: {
          line: 19,
          column: 37
        }
      },
      "10": {
        start: {
          line: 20,
          column: 6
        },
        end: {
          line: 20,
          column: 26
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        },
        line: 8
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 8,
            column: 3
          }
        },
        loc: {
          start: {
            line: 8,
            column: 18
          },
          end: {
            line: 22,
            column: 3
          }
        },
        line: 8
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 10,
            column: 6
          },
          end: {
            line: 10,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 6
          },
          end: {
            line: 10,
            column: 38
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 10
      },
      "1": {
        loc: {
          start: {
            line: 14,
            column: 6
          },
          end: {
            line: 14,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 14,
            column: 6
          },
          end: {
            line: 14,
            column: 42
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 14
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "2a9b4835d8ff0aca79aa0ba3c58ba81f0c64917e"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2da4l8odm5 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2da4l8odm5();
cov_2da4l8odm5().s[0]++;
export var createNormalizeChecking = function createNormalizeChecking(transform, validate, descriptionError, defaultValue) {
  cov_2da4l8odm5().f[0]++;
  cov_2da4l8odm5().s[1]++;
  return function (value) {
    cov_2da4l8odm5().f[1]++;
    cov_2da4l8odm5().s[2]++;
    try {
      cov_2da4l8odm5().s[3]++;
      if (!value) {
        cov_2da4l8odm5().b[0][0]++;
        cov_2da4l8odm5().s[4]++;
        return defaultValue;
      } else {
        cov_2da4l8odm5().b[0][1]++;
      }
      var result = (cov_2da4l8odm5().s[5]++, transform(value));
      cov_2da4l8odm5().s[6]++;
      if (validate(result)) {
        cov_2da4l8odm5().b[1][0]++;
        cov_2da4l8odm5().s[7]++;
        return result;
      } else {
        cov_2da4l8odm5().b[1][1]++;
      }
      cov_2da4l8odm5().s[8]++;
      throw new Error('Incorrect value');
    } catch (_unused) {
      cov_2da4l8odm5().s[9]++;
      // eslint-disable-next-line no-console
      console.warn(descriptionError);
      cov_2da4l8odm5().s[10]++;
      return defaultValue;
    }
  };
};